import { render, staticRenderFns } from "./DeclarativeSection.vue?vue&type=template&id=6ce9b225&scoped=true"
import script from "./DeclarativeSection.vue?vue&type=script&lang=js"
export * from "./DeclarativeSection.vue?vue&type=script&lang=js"
import style0 from "./DeclarativeSection.vue?vue&type=style&index=0&id=6ce9b225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce9b225",
  null
  
)

export default component.exports